module.exports = __webpack_public_path__ + "static/media/competence.a81975aa.svg";